import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap';

export const RatingModal = ({ showModal, onHide, rating, onSubmit, lineid, rl }) => {
    const [feedback, setFeedback] = useState('');

    useEffect(() => {
        if (!showModal) {
            setFeedback('');
        }
    }, [showModal]);

    const handleSubmit = () => {
        onSubmit(rating, lineid, rl, feedback);
        onHide();
    };

    const renderContent = (ratingVal) => {
        if (ratingVal === 1 || ratingVal === 5) {
            return (
                <div className="d-block">
                    <p className="mb-3">{ratingVal === 1 ? 'Your rating is very low. Please provide feedback.' : 'Thank you for your excellent rating!'}</p>
                    <Form.Control as="textarea" rows={5} value={feedback} onChange={(e) => setFeedback(e.target.value)} />
                </div>
            );
        }
        return null;
    };

    return (
        <Modal show={showModal} onHide={onHide}>
            <Modal.Header closeButton closeVariant='white'>
                <Modal.Title>Feedback</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderContent(rating)}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

RatingModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    rating: PropTypes.number,
    onSubmit: PropTypes.func.isRequired,
    lineid: PropTypes.number,
    rl: PropTypes.any,
};

export default RatingModal;
